"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The MediaSlide model module.
 * @module model/MediaSlide
 * @version 1.1.3-alpha.1
 */
class MediaSlide {
  /**
   * Constructs a new <code>MediaSlide</code>.
   * @alias module:model/MediaSlide
   * @param media_id {String} 
   * @param slide_number {Number} 
   * @param content_id {String} 
   * @param allow_comments {Boolean} 
   * @param title {String} 
   * @param is_topline {Boolean} 
   * @param id {String} 
   * @param created_at {String} 
   * @param updated_at {String} 
   */
  constructor(media_id, slide_number, content_id, allow_comments, title, is_topline, id, created_at, updated_at) {
    MediaSlide.initialize(this, media_id, slide_number, content_id, allow_comments, title, is_topline, id, created_at, updated_at);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, media_id, slide_number, content_id, allow_comments, title, is_topline, id, created_at, updated_at) {
    obj['media_id'] = media_id;
    obj['slide_number'] = slide_number;
    obj['content_id'] = content_id;
    obj['allow_comments'] = allow_comments;
    obj['title'] = title;
    obj['is_topline'] = is_topline;
    obj['id'] = id;
    obj['created_at'] = created_at;
    obj['updated_at'] = updated_at;
  }

  /**
   * Constructs a <code>MediaSlide</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MediaSlide} obj Optional instance to populate.
   * @return {module:model/MediaSlide} The populated <code>MediaSlide</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MediaSlide();
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('slide_number')) {
        obj['slide_number'] = _ApiClient.default.convertToType(data['slide_number'], 'Number');
      }
      if (data.hasOwnProperty('content_id')) {
        obj['content_id'] = _ApiClient.default.convertToType(data['content_id'], 'String');
      }
      if (data.hasOwnProperty('price')) {
        obj['price'] = _ApiClient.default.convertToType(data['price'], 'Number');
      }
      if (data.hasOwnProperty('allow_comments')) {
        obj['allow_comments'] = _ApiClient.default.convertToType(data['allow_comments'], 'Boolean');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('is_topline')) {
        obj['is_topline'] = _ApiClient.default.convertToType(data['is_topline'], 'Boolean');
      }
      if (data.hasOwnProperty('download_file_id')) {
        obj['download_file_id'] = _ApiClient.default.convertToType(data['download_file_id'], 'String');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('created_at')) {
        obj['created_at'] = _ApiClient.default.convertToType(data['created_at'], 'String');
      }
      if (data.hasOwnProperty('created_by')) {
        obj['created_by'] = _ApiClient.default.convertToType(data['created_by'], 'String');
      }
      if (data.hasOwnProperty('date_created')) {
        obj['date_created'] = _ApiClient.default.convertToType(data['date_created'], 'String');
      }
      if (data.hasOwnProperty('time_created')) {
        obj['time_created'] = _ApiClient.default.convertToType(data['time_created'], 'String');
      }
      if (data.hasOwnProperty('updated_at')) {
        obj['updated_at'] = _ApiClient.default.convertToType(data['updated_at'], 'String');
      }
      if (data.hasOwnProperty('updated_by')) {
        obj['updated_by'] = _ApiClient.default.convertToType(data['updated_by'], 'String');
      }
      if (data.hasOwnProperty('date_updated')) {
        obj['date_updated'] = _ApiClient.default.convertToType(data['date_updated'], 'String');
      }
      if (data.hasOwnProperty('time_updated')) {
        obj['time_updated'] = _ApiClient.default.convertToType(data['time_updated'], 'String');
      }
      if (data.hasOwnProperty('deleted_at')) {
        obj['deleted_at'] = _ApiClient.default.convertToType(data['deleted_at'], 'String');
      }
      if (data.hasOwnProperty('deleted_by')) {
        obj['deleted_by'] = _ApiClient.default.convertToType(data['deleted_by'], 'String');
      }
      if (data.hasOwnProperty('date_deleted')) {
        obj['date_deleted'] = _ApiClient.default.convertToType(data['date_deleted'], 'String');
      }
      if (data.hasOwnProperty('time_deleted')) {
        obj['time_deleted'] = _ApiClient.default.convertToType(data['time_deleted'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>MediaSlide</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaSlide</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of MediaSlide.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    // ensure the json data is a string
    if (data['content_id'] && !(typeof data['content_id'] === 'string' || data['content_id'] instanceof String)) {
      throw new Error("Expected the field `content_id` to be a primitive type in the JSON string but got " + data['content_id']);
    }
    // ensure the json data is a string
    if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
      throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
    }
    // ensure the json data is a string
    if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
      throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
    }
    // ensure the json data is a string
    if (data['download_file_id'] && !(typeof data['download_file_id'] === 'string' || data['download_file_id'] instanceof String)) {
      throw new Error("Expected the field `download_file_id` to be a primitive type in the JSON string but got " + data['download_file_id']);
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
      throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
    }
    // ensure the json data is a string
    if (data['time_created'] && !(typeof data['time_created'] === 'string' || data['time_created'] instanceof String)) {
      throw new Error("Expected the field `time_created` to be a primitive type in the JSON string but got " + data['time_created']);
    }
    // ensure the json data is a string
    if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
      throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
    }
    // ensure the json data is a string
    if (data['time_updated'] && !(typeof data['time_updated'] === 'string' || data['time_updated'] instanceof String)) {
      throw new Error("Expected the field `time_updated` to be a primitive type in the JSON string but got " + data['time_updated']);
    }
    // ensure the json data is a string
    if (data['deleted_by'] && !(typeof data['deleted_by'] === 'string' || data['deleted_by'] instanceof String)) {
      throw new Error("Expected the field `deleted_by` to be a primitive type in the JSON string but got " + data['deleted_by']);
    }
    // ensure the json data is a string
    if (data['time_deleted'] && !(typeof data['time_deleted'] === 'string' || data['time_deleted'] instanceof String)) {
      throw new Error("Expected the field `time_deleted` to be a primitive type in the JSON string but got " + data['time_deleted']);
    }
    return true;
  }
}
MediaSlide.RequiredProperties = ["media_id", "slide_number", "content_id", "allow_comments", "title", "is_topline", "id", "created_at", "updated_at"];

/**
 * @member {String} media_id
 */
MediaSlide.prototype['media_id'] = undefined;

/**
 * @member {Number} slide_number
 */
MediaSlide.prototype['slide_number'] = undefined;

/**
 * @member {String} content_id
 */
MediaSlide.prototype['content_id'] = undefined;

/**
 * @member {Number} price
 */
MediaSlide.prototype['price'] = undefined;

/**
 * @member {Boolean} allow_comments
 */
MediaSlide.prototype['allow_comments'] = undefined;

/**
 * @member {String} title
 */
MediaSlide.prototype['title'] = undefined;

/**
 * @member {String} description
 */
MediaSlide.prototype['description'] = undefined;

/**
 * @member {Boolean} is_topline
 */
MediaSlide.prototype['is_topline'] = undefined;

/**
 * @member {String} download_file_id
 */
MediaSlide.prototype['download_file_id'] = undefined;

/**
 * @member {String} id
 */
MediaSlide.prototype['id'] = undefined;

/**
 * @member {String} created_at
 */
MediaSlide.prototype['created_at'] = undefined;

/**
 * @member {String} created_by
 */
MediaSlide.prototype['created_by'] = undefined;

/**
 * @member {String} date_created
 */
MediaSlide.prototype['date_created'] = undefined;

/**
 * @member {String} time_created
 */
MediaSlide.prototype['time_created'] = undefined;

/**
 * @member {String} updated_at
 */
MediaSlide.prototype['updated_at'] = undefined;

/**
 * @member {String} updated_by
 */
MediaSlide.prototype['updated_by'] = undefined;

/**
 * @member {String} date_updated
 */
MediaSlide.prototype['date_updated'] = undefined;

/**
 * @member {String} time_updated
 */
MediaSlide.prototype['time_updated'] = undefined;

/**
 * @member {String} deleted_at
 */
MediaSlide.prototype['deleted_at'] = undefined;

/**
 * @member {String} deleted_by
 */
MediaSlide.prototype['deleted_by'] = undefined;

/**
 * @member {String} date_deleted
 */
MediaSlide.prototype['date_deleted'] = undefined;

/**
 * @member {String} time_deleted
 */
MediaSlide.prototype['time_deleted'] = undefined;
var _default = exports.default = MediaSlide;